import { Link } from "react-router-dom";
import { Lock, ArrowRight, Check } from "lucide-react";
import { CV_GATE_MESSAGE } from "./cvContent";

// Bramka rejestracji: pojawia się dopiero przed pełnym formularzem / zapisem / kredytem.
export const CvGate = ({ returnTo = "/cv/kreator", message = CV_GATE_MESSAGE, testId = "cv-gate" }) => {
  const enc = encodeURIComponent(returnTo);
  return (
    <div
      data-testid={testId}
      className="rounded-panel border border-brand-accent/40 bg-brand-accent/[0.06] p-6 sm:p-8"
    >
      <div className="flex items-center gap-2 text-brand-accent">
        <Lock size={18} strokeWidth={2} />
        <span className="font-display text-base font-semibold">{message}</span>
      </div>
      <ul className="mt-4 space-y-2 text-sm text-brand-sec">
        <li className="flex items-center gap-2"><Check size={15} className="text-brand-accent" /> Wypełnisz pełny wywiad i przygotujesz kompletne CV</li>
        <li className="flex items-center gap-2"><Check size={15} className="text-brand-accent" /> Zapiszesz i pobierzesz dokument (PDF/DOCX)</li>
        <li className="flex items-center gap-2"><Check size={15} className="text-brand-accent" /> Znajdziesz bazę dopasowanych pracodawców</li>
      </ul>
      <div className="mt-6 flex flex-col gap-3 sm:flex-row">
        <Link
          to={`/rejestracja?returnTo=${enc}`}
          data-testid="cv-gate-register"
          className="inline-flex items-center justify-center gap-2 rounded-button bg-brand-accent px-6 py-3 text-sm font-semibold text-brand-on transition-transform hover:-translate-y-0.5"
        >
          Załóż bezpłatne konto <ArrowRight size={16} />
        </Link>
        <Link
          to={`/logowanie?returnTo=${enc}`}
          data-testid="cv-gate-login"
          className="inline-flex items-center justify-center gap-2 rounded-button border border-brand-line px-6 py-3 text-sm font-semibold text-brand-text transition-colors hover:border-brand-accent/60"
        >
          Zaloguj się
        </Link>
      </div>
      <p className="mt-4 text-[12.5px] text-brand-muted">
        Podgląd jest bezpłatny i tylko do odczytu. Nie pobieramy kredytów i nie zapisujemy Twojej pracy, dopóki nie przejdziesz dalej.
      </p>
    </div>
  );
};
